export default "__VITE_ASSET__yHEPSjzf__"